var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xtxqlj-page"},[_c('HeroSection'),_vm._v(" "),_c('About'),_vm._v(" "),_c('Tongxue'),_vm._v(" "),_c('Activity'),_vm._v(" "),_c('More')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }